import { gql } from '@apollo/client';

export interface RemoveCourseMutationVariables {
  courseId: string;
}

export interface RemoveCourseMutationResult {
  course: {
    _id: string;
  };
}

export const removeCourseMutation = gql`
  mutation RemoveCourse($courseId: String!) {
    course(courseId: $courseId) @rest(type: "Course", path: "courses/{args.courseId}", method: "DELETE") {
      _id
    }
  }
`;
